module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_08-f0fcc05b8bcd23f4bbcff35b0f1faed4.png";